/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Payment_HistoryInputs */

const en_nav_payment_history = /** @type {(inputs: Nav_Payment_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment History`)
};

const es_nav_payment_history = /** @type {(inputs: Nav_Payment_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historial de pagos`)
};

/**
* | output |
* | --- |
* | "Payment History" |
*
* @param {Nav_Payment_HistoryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_payment_history = /** @type {((inputs?: Nav_Payment_HistoryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Payment_HistoryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_payment_history(inputs)
	return es_nav_payment_history(inputs)
});